var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWavyCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.994,
    height: 18,
    viewBox: "0 0 17.994 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "verify",
    d: "M19.6,9.862,18.377,8.441a1.994,1.994,0,0,1-.423-1.134V5.777a1.743,1.743,0,0,0-1.737-1.737h-1.53a2.018,2.018,0,0,1-1.134-.423L12.133,2.394a1.813,1.813,0,0,0-2.267,0L8.453,3.627a2.076,2.076,0,0,1-1.134.414H5.762A1.743,1.743,0,0,0,4.026,5.777V7.316a2.047,2.047,0,0,1-.414,1.125L2.4,9.871a1.812,1.812,0,0,0,0,2.249l1.215,1.431a2.047,2.047,0,0,1,.414,1.125v1.539a1.743,1.743,0,0,0,1.737,1.737H7.319a2.018,2.018,0,0,1,1.134.423L9.874,19.6a1.813,1.813,0,0,0,2.267,0l1.422-1.224a1.994,1.994,0,0,1,1.134-.423h1.53a1.743,1.743,0,0,0,1.737-1.737v-1.53a2.018,2.018,0,0,1,.423-1.134L19.61,12.13A1.825,1.825,0,0,0,19.6,9.862ZM14.742,9.3l-3.121,3.121L10.4,13.641a.673.673,0,0,1-.954,0L7.265,11.464a.674.674,0,1,1,.954-.954l1.7,1.7,3.869-3.869a.674.674,0,1,1,.954.954Z",
    transform: "translate(-2.006 -1.996)",
    fill: "#387f75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavyCheck);
export default __webpack_public_path__ + "static/media/wavy-check.4b37a337aca2fc28bbd578a35f24e822.svg";
export { ForwardRef as ReactComponent };